import { useEffect, useState } from "react";
import { getAllCategories } from "../../utils/service";

const CategorySelect = ({ onChange, vocabId, categoryLbl }) => {

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAllCategories(vocabId);
                console.log("categories : ", response);
                setCategories(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleSelectCategory = (categoryId, categoryLabel) => {
        const selectedValue = categoryId;
        onChange(selectedValue || "", categoryLabel || "");
        toggleDropdown(false);
    }

    const toggleDropdown = (show = true) => {   
        const input = document.getElementById('select-from-list-input');
        const dropdown = document.getElementById('dropdown');
        dropdown.classList.toggle('d-block', show);
        input.setAttribute('aria-expanded', show.toString());
    }

    useEffect(() => { 
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.select-from-list')) {
                toggleDropdown(false);
            }
        });
    }, []); 


    return (
        <>
           
        
            <div class="select-from-list">
                <div class="form-group mb-0">
                    <label id="select-from-list-input-label" className="d-none">Select an Option</label>
                    <div class="align-items-end input-group">
                        <div class="input-group-item">
                            <input
                                class="form-control form-input d-none"
                                id="select-from-list-input"
                                name="selectedOption"
                                placeholder="Type to search..."
                                role="combobox"
                                aria-autocomplete="list"
                                aria-controls="listbox"
                                aria-expanded="false"
                                onFocus={() => toggleDropdown(true)}
                                onInput={() => toggleDropdown(true)}
                            />
                            <button type="button" className="form-input" onClick={() => toggleDropdown(true)}>
                                {categoryLbl || `${Liferay.Language.get("dwtc.services.categories")}`}
                            </button>
                        </div>
                        <div class="icn-container align-self-center">
                           <svg
                                className="lexicon-icon lexicon-icon-angle-down"
                                role="presentation"
                            >
                                <use href="http://localhost:8080/o/classic-theme/images/clay/icons.svg#angle-down" />
                            </svg>
			
                        </div>
                        

                        <div class="dropdown-menu select-from-list__dropdown-menu" id="dropdown">
                            <p class="mb-0 px-3 py-2 text-muted" id="choose-option-message">Choose an option</p>
                            <p class="d-none mb-0 px-3 py-2 text-muted" id="loading-results-message">Loading...</p>
                            <p class="d-none mb-0 px-3 py-2 text-muted" id="no-results-message">No results found</p>

                            <ul class="list-unstyled" id="listbox" role="listbox">
                                <li data-label="All" data-value="" key="all" className="dropdown-item" role="option" onClick={() => handleSelectCategory("", "")}>{'All'}</li>
                                {categories.length > 0 && categories.map((category) => {
                                    return <li onClick={() => handleSelectCategory(category.id, category.name)} data-label={category.name} data-value={category.id} key={category.id} className="dropdown-item" role="option">{category.name}</li>
                                })}
                            </ul>
                        </div>
                    </div>
                    <p class="font-weight-semi-bold mt-1 text-danger d-none" id="select-from-list-input-error-message">⚠ Error message goes here</p>
                </div>
            </div>

        
        </>
        
    );
}

export default CategorySelect;